// Recovered compiled webpack factory 24362. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      createRouteLoader: function () {
        return m;
      },
      getClientBuildManifest: function () {
        return h;
      },
      isAssetError: function () {
        return c;
      },
      markAssetError: function () {
        return u;
      },
    }),
    r(28140),
    r(80749));
  let n = r(35e3),
    a = r(4853),
    o = r(98301),
    i = r(77278);
  function s(e, t, r) {
    let n,
      a = t.get(e);
    if (a) return "future" in a ? a.future : Promise.resolve(a);
    let o = new Promise((e) => {
      n = e;
    });
    return (
      t.set(e, { resolve: n, future: o }),
      r
        ? r()
            .then((e) => (n(e), e))
            .catch((r) => {
              throw (t.delete(e), r);
            })
        : o
    );
  }
  let l = Symbol("ASSET_LOAD_ERROR");
  function u(e) {
    return Object.defineProperty(e, l, {});
  }
  function c(e) {
    return e && l in e;
  }
  let f = (function (e) {
      try {
        return (
          (e = document.createElement("link")),
          (!!window.MSInputMethodContext && !!document.documentMode) ||
            e.relList.supports("prefetch")
        );
      } catch (e) {
        return !1;
      }
    })(),
    d = () => (0, o.getDeploymentIdQueryOrEmptyString)();
  function p(e, t, r) {
    return new Promise((n, o) => {
      let i = !1;
      (e
        .then((e) => {
          ((i = !0), n(e));
        })
        .catch(o),
        (0, a.requestIdleCallback)(() =>
          setTimeout(() => {
            i || o(r);
          }, t),
        ));
    });
  }
  function h() {
    return self.__BUILD_MANIFEST
      ? Promise.resolve(self.__BUILD_MANIFEST)
      : p(
          new Promise((e) => {
            let t = self.__BUILD_MANIFEST_CB;
            self.__BUILD_MANIFEST_CB = () => {
              (e(self.__BUILD_MANIFEST), t && t());
            };
          }),
          3800,
          u(
            Object.defineProperty(
              Error("Failed to load client build manifest"),
              "__NEXT_ERROR_CODE",
              { value: "E273", enumerable: !1, configurable: !0 },
            ),
          ),
        );
  }
  function _(e, t) {
    return h().then((r) => {
      if (!(t in r))
        throw u(
          Object.defineProperty(Error("Failed to lookup route: " + t), "__NEXT_ERROR_CODE", {
            value: "E446",
            enumerable: !1,
            configurable: !0,
          }),
        );
      let a = r[t].map((t) => e + "/_next/" + (0, i.encodeURIPath)(t));
      return {
        scripts: a
          .filter((e) => e.endsWith(".js"))
          .map((e) => (0, n.__unsafeCreateTrustedScriptURL)(e) + d()),
        css: a.filter((e) => e.endsWith(".css")).map((e) => e + d()),
      };
    });
  }
  function m(e) {
    let t = new Map(),
      r = new Map(),
      n = new Map(),
      o = new Map();
    function i(e) {
      {
        var t;
        let n = r.get(e.toString());
        return n
          ? n
          : document.querySelector('script[src^="' + e + '"]')
            ? Promise.resolve()
            : (r.set(
                e.toString(),
                (n = new Promise((r, n) => {
                  (((t = document.createElement("script")).onload = r),
                    (t.onerror = () =>
                      n(
                        u(
                          Object.defineProperty(
                            Error("Failed to load script: " + e),
                            "__NEXT_ERROR_CODE",
                            { value: "E74", enumerable: !1, configurable: !0 },
                          ),
                        ),
                      )),
                    (t.crossOrigin = void 0),
                    (t.src = e),
                    document.body.appendChild(t));
                })),
              ),
              n);
      }
    }
    function l(e) {
      let t = n.get(e);
      return (
        t ||
          n.set(
            e,
            (t = fetch(e, { credentials: "same-origin" })
              .then((t) => {
                if (!t.ok)
                  throw Object.defineProperty(
                    Error("Failed to load stylesheet: " + e),
                    "__NEXT_ERROR_CODE",
                    { value: "E189", enumerable: !1, configurable: !0 },
                  );
                return t.text().then((t) => ({ href: e, content: t }));
              })
              .catch((e) => {
                throw u(e);
              })),
          ),
        t
      );
    }
    return {
      whenEntrypoint: (e) => s(e, t),
      onEntrypoint(e, r) {
        (r
          ? Promise.resolve()
              .then(() => r())
              .then(
                (e) => ({ component: (e && e.default) || e, exports: e }),
                (e) => ({ error: e }),
              )
          : Promise.resolve(void 0)
        ).then((r) => {
          let n = t.get(e);
          n && "resolve" in n
            ? r && (t.set(e, r), n.resolve(r))
            : (r ? t.set(e, r) : t.delete(e), o.delete(e));
        });
      },
      loadRoute(r, n) {
        return s(r, o, () => {
          let a;
          return p(
            _(e, r)
              .then((e) => {
                let { scripts: n, css: a } = e;
                return Promise.all([t.has(r) ? [] : Promise.all(n.map(i)), Promise.all(a.map(l))]);
              })
              .then((e) => this.whenEntrypoint(r).then((t) => ({ entrypoint: t, styles: e[1] }))),
            3800,
            u(
              Object.defineProperty(
                Error("Route did not complete loading: " + r),
                "__NEXT_ERROR_CODE",
                { value: "E12", enumerable: !1, configurable: !0 },
              ),
            ),
          )
            .then((e) => {
              let { entrypoint: t, styles: r } = e,
                n = Object.assign({ styles: r }, t);
              return "error" in t ? t : n;
            })
            .catch((e) => {
              if (n) throw e;
              return { error: e };
            })
            .finally(() => (null == a ? void 0 : a()));
        });
      },
      prefetch(t) {
        let r;
        return (r = navigator.connection) && (r.saveData || /2g/.test(r.effectiveType))
          ? Promise.resolve()
          : _(e, t)
              .then((e) =>
                Promise.all(
                  f
                    ? e.scripts.map((e) => {
                        var t, r, n;
                        return (
                          (t = e.toString()),
                          (r = "script"),
                          new Promise((e, a) => {
                            let o =
                              '\n      link[rel="prefetch"][href^="' +
                              t +
                              '"],\n      link[rel="preload"][href^="' +
                              t +
                              '"],\n      script[src^="' +
                              t +
                              '"]';
                            if (document.querySelector(o)) return e();
                            ((n = document.createElement("link")),
                              r && (n.as = r),
                              (n.rel = "prefetch"),
                              (n.crossOrigin = void 0),
                              (n.onload = e),
                              (n.onerror = () =>
                                a(
                                  u(
                                    Object.defineProperty(
                                      Error("Failed to prefetch: " + t),
                                      "__NEXT_ERROR_CODE",
                                      { value: "E268", enumerable: !1, configurable: !0 },
                                    ),
                                  ),
                                )),
                              (n.href = t),
                              document.head.appendChild(n));
                          })
                        );
                      })
                    : [],
                ),
              )
              .then(() => {
                (0, a.requestIdleCallback)(() => this.loadRoute(t, !0).catch(() => {}));
              })
              .catch(() => {});
      },
    };
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
